import cs from 'classnames';

import type { ReactNode } from 'react';
import { Card } from 'ui';
import { TwoColumnLayout } from '../two-column-layout';

type P = {
  className?: string;
  left: ReactNode;
  right?: ReactNode;
};

const HeaderWrapper = ({ className, left, right }: P) => (
  <Card className={cs('header-wrapper', className)} shrinked>
    {right ? (
      <TwoColumnLayout left={left} right={right} rightOptions={{ className: 'header-wrapper__right' }} />
    ) : (
      <>{left}</>
    )}
  </Card>
);

export default HeaderWrapper;
